var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5835 21.5833H14.5835M7.5835 21.5833V15.75M7.5835 21.5833H1.2835C1.09784 21.5833 0.919797 21.5096 0.788521 21.3783C0.657246 21.247 0.583496 21.069 0.583496 20.8833V16.45C0.583496 16.2644 0.657246 16.0863 0.788521 15.955C0.919797 15.8238 1.09784 15.75 1.2835 15.75H7.5835M14.5835 21.5833V7.58334M14.5835 21.5833H20.8835C21.0691 21.5833 21.2472 21.5096 21.3785 21.3783C21.5097 21.247 21.5835 21.069 21.5835 20.8833V1.28334C21.5835 1.09769 21.5097 0.919644 21.3785 0.788369C21.2472 0.657093 21.0691 0.583344 20.8835 0.583344H15.2835C15.0978 0.583344 14.9198 0.657093 14.7885 0.788369C14.6572 0.919644 14.5835 1.09769 14.5835 1.28334V7.58334M7.5835 15.75V8.28334C7.5835 8.09769 7.65725 7.91964 7.78852 7.78837C7.9198 7.65709 8.09784 7.58334 8.2835 7.58334H14.5835",
    stroke: "white",
    strokeWidth: 1.16667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIconWhite);
export default __webpack_public_path__ + "static/media/ReportsIconWhite.a40ab44390b68d75e2ab2b98ba6f4e5f.svg";
export { ForwardRef as ReactComponent };